import {
  black,
  createBaseTheme,
  darkGray,
  turquoise7,
  turquoise9,
  ultraDarkGray,
} from "shared-ts-mui";
import { darken, lighten } from "@mui/material";

const airmontTurquoiseLight = "#9ACCCC";
const airmontTurquoiseDark = "#669999";
const airmontTurquoiseLightSecondary = "#98acac";
const airmontTurquoiseDarker = "#4c807f";

const default_background = "#e5fafa";
const default_background_paper = "#eee";
const super_light_turquoise = "#F5FAFA";
const turquoiseHover = turquoise9;
const turquoiseHoverText = ultraDarkGray;

export const lightTheme = createBaseTheme({
  cssVariables: true,
  palette: {
    mode: "light",
    primary: {
      main: airmontTurquoiseDark,
      light: default_background,
    },
    secondary: {
      main: airmontTurquoiseLightSecondary, //lighten(airmontTurquoiseDark, 0.2),
      dark: airmontTurquoiseDarker,//lighten(airmontTurquoiseDark, 0.1),
      // light: super_light_turquoise,
      contrastText: "#ffffff",
    },
    background: {
      default: default_background,
      paper: default_background_paper,
      card: super_light_turquoise,
    },
    text: {
      primary: darkGray,
    },
    input: {
      background: lighten(default_background_paper, 0.5),
      hover: darken(default_background_paper, 0.05),
    },
    action: {
      selected: airmontTurquoiseLight,
      //selectedText: white,
      hover: turquoiseHover,
      hoverText: turquoiseHoverText,
      hoverOpacity: 0.2,
    },
    actionGroup: {
      //standard farge
      primary: super_light_turquoise,
      primaryText: ultraDarkGray,
      selected: turquoise7, //darken(airmontTurquoise, 0.3),
      selectedText: black,
      hover: turquoiseHover,
      hoverText: turquoiseHoverText,
    },
  },
});
